export const hasMutation = (content, language) => {
  const title = content.title;
  if (title[language]) {
    return true;
  }
  return false;
};



// WEBPACK FOOTER //
// ./src/modules/ContactList/utils.js